export enum Role {
  ADMIN = 'ats_super_admin',
  USER = 'ats_studiotel_user',
  DEV = 'ats_dev'
}
